import gql from 'graphql-tag';

export default gql`
    mutation DeleteDriverLoadNotes($input: DeleteDriverLoadNotes) {
        deleteDriverLoadNotes(input: $input) {
            errors
        }
    }
`;
